import { Box, Typography } from '@mui/material';
import { ReactComponent as Bladesicon } from '@src/assets/icons/categories/blades.svg';
import { ReactComponent as Consumables } from '@src/assets/icons/categories/consumables.svg';
import { ReactComponent as Dressings } from '@src/assets/icons/categories/dressings.svg';
import { ReactComponent as Fluids } from '@src/assets/icons/categories/fluids.svg';
import { ReactComponent as Hypodermics } from '@src/assets/icons/categories/hypodermics.svg';
import { ReactComponent as Infiltration } from '@src/assets/icons/categories/infiltration.svg';
import { ReactComponent as InstrumentSets } from '@src/assets/icons/categories/instrument_sets.svg';
import { ReactComponent as SkinPreparation } from '@src/assets/icons/categories/skin_preparation.svg';
import { ReactComponent as SupplementarySets } from '@src/assets/icons/categories/supplementary_sets.svg';
import { ReactComponent as Sutures } from '@src/assets/icons/categories/sutures.svg';
import { ReactComponent as TableExtras } from '@src/assets/icons/categories/table_extras.svg';
import { useMemo } from 'react';

interface Props {
  name: string;
  count?: number;
}

function CategoryHeader({ name, count }: Props) {
  const iconBackgroundColor = useMemo(() => {
    switch (name) {
      case 'Trays & Instrument Sets':
        return 'rgb(255, 231, 242)';
      case 'Supplementary Instruments':
        return 'rgba(255, 231, 242, 1)';
      case 'Sutures':
        return 'rgba(228, 218, 252, 1)';
      case 'Dressings':
        return '#FFF4E3';
      case 'Blades':
        return '#FFF4E3';
      case 'Hypodermics':
        return '#FFEDE3';
      case 'Fluids':
        return '#DAF9FE';
      case 'Infiltration':
        return '#DAF9FE';
      case 'Consumables':
        return 'rgba(222, 247, 228, 1)';
      case 'Table Extras':
        return '#FFEDE3';
      case 'Skin Preparation':
      default:
        return 'rgba(228, 218, 252, 1)';
    }
  }, [name]);

  const icon = useMemo(() => {
    switch (name) {
      case 'Trays & Instrument Sets':
        return <InstrumentSets />;
      case 'Supplementary Instruments':
        return <SupplementarySets />;
      case 'Sutures':
        return <Sutures />;
      case 'Dressings':
        return <Dressings />;
      case 'Blades':
        return <Bladesicon />;
      case 'Hypodermics':
        return <Hypodermics />;
      case 'Fluids':
        return <Fluids />;
      case 'Infiltration':
        return <Infiltration />;
      case 'Consumables':
        return <Consumables />;
      case 'Table Extras':
        return <TableExtras />;
      case 'Skin Preparation':
      default:
        return <SkinPreparation />;
    }
  }, [name]);

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        spacing: theme.spacing(1),
      })}>
      <Box
        sx={(theme) => ({
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(1),
          padding: theme.spacing(1),
          backgroundColor: iconBackgroundColor,
          borderRadius: theme.spacing(1),
          display: 'flex',
        })}>
        {icon}
      </Box>
      <Box sx={{ width: '325px' }}>
        <Typography variant="h6">
          {name} {count ? `(${count})` : ''}
        </Typography>
      </Box>
    </Box>
  );
}

export default CategoryHeader;
